var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag_wrapper",class:{ activited: _vm.activited }},[(_vm.icon)?_c('img',{staticClass:"icon",attrs:{"src":_vm.icon}}):_vm._e(),_c('span',{style:({ color: _vm.activited ? _vm.activeColor : '#bbbbbb' })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }